/**
 * When the backend floor-plan endpoints are live, set this to `true`.
 *
 * - false (default): the feature runs entirely off the local persisted zustand
 *   store (useFloorPlanStore). No network calls are made.
 * - true: useFloorPlanQuery hydrates the store from the API on mount and
 *   useFloorPlanMutations mirrors every change to the backend.
 *
 * Components do not change between the two modes, they only consume the store
 * and the mutation hook, both of which honour this flag.
 */
export const FLOOR_PLAN_USE_API = true
